import React from 'react';
import ContactInfo from '../components/ContactInfo';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div className="contact">
      <div className="container">
        <h1>Contact Us & Book Your Tour</h1>

        <div className="contact-content">
          <ContactInfo />
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
